import { useCallback, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PinChangeOption } from '@eika-kortbetjening/pin-change-decision-form';

import { SearchParams } from '@domain/app';
import { useOrderAvailableAccounts } from '@hooks/account/use-order-available-accounts';

import { orderCardSteps } from './steps';

export const useStepsControll = () => {
    const accounts = useOrderAvailableAccounts();
    const [searchParams, setSearchParams] = useSearchParams();

    const step = searchParams.get('step') || '';
    const selectedAccountNumber = searchParams.get('kontonummer');

    const availableAccounts = useMemo(() => [...new Set(accounts)], [accounts]);

    useEffect(() => {
        if (!Object.values(orderCardSteps).includes(step)) {
            setSearchParams(
                (prev) => {
                    prev.set('step', orderCardSteps.chooseAccount);
                    return prev;
                },
                { replace: true },
            );
        }
    }, [setSearchParams, step]);

    const toNextStep = useCallback(() => {
        if (step === orderCardSteps.chooseAccount) {
            const selectedAccount = availableAccounts.find((acc) => acc.number === selectedAccountNumber);

            if (selectedAccount) {
                if (selectedAccount.allowedOperations.setCardPin) {
                    setSearchParams((prev) => {
                        prev.set('step', orderCardSteps.keepPinDecision);
                        prev.set(SearchParams.PIN_DECISION, PinChangeOption.KEEP_PIN);
                        return prev;
                    });
                    return;
                }
            }
        }

        if (step === orderCardSteps.keepPinDecision) {
            const setNewPin = searchParams.get(SearchParams.PIN_DECISION);

            if (setNewPin === PinChangeOption.CHANGE_PIN) {
                setSearchParams((prev) => {
                    prev.set('step', orderCardSteps.choosePin);
                    return prev;
                });
                return;
            }
        }

        setSearchParams((prev) => {
            prev.set('step', orderCardSteps.summary);
            return prev;
        });
    }, [availableAccounts, searchParams, selectedAccountNumber, setSearchParams, step]);

    return { step, toNextStep };
};
